import { setProductViewed } from './Shared/google_tag_manager.js';

export function recordAddToCart(selectedOption, quantity) {
   recordGoogleAddToCart(selectedOption, quantity);
   recordFacebookAddToCart(selectedOption, quantity);
}

function recordGoogleAddToCart(selectedOption, quantity) {
   var addToCartProductInfo = getGASelectedProduct(selectedOption);
   addToCartProductInfo.quantity = quantity;

   // Essentially the itemcode without the leading 'IF'
   const { productcode, optionid } = Utils.parseItemcode(App.itemcode);
   const eventLabel = productcode + '-' + optionid;

   ga('ifixit.ec:addProduct', addToCartProductInfo);
   ga('ifixit.ec:setAction', 'add');
   ga('ifixit.send', 'event', 'Products', 'Add to Cart', eventLabel);
}

function recordFacebookAddToCart(selectedOption, quantity) {
   const addToCartProductInfo = getFacebookSelectedProduct(selectedOption);

   // 'contents' within the Facebook tracking payload must be an array, but we
   // only ever have one element in it.
   addToCartProductInfo.contents[0].quantity = quantity;
   addToCartProductInfo.value *= quantity;

   fbq('track', 'AddToCart', addToCartProductInfo);
}

export function recordProductView(selectedOption) {
   recordGoogleProductView(selectedOption);
   recordFacebookProductView(selectedOption);
}

function recordGoogleProductView(selectedOption) {
   const gaSelectedProduct = getGASelectedProduct(selectedOption);

   ga('ifixit.ec:addProduct', gaSelectedProduct);
   ga('ifixit.ec:setAction', 'detail');
   ga('ifixit.send', 'pageview');
   window.App.gaFired = true;

   setProductViewed(App.sku, gaSelectedProduct.price);
}

function recordFacebookProductView(selectedOption) {
   var viewProductInfo = getFacebookSelectedProduct(selectedOption);
   fbq('track', 'ViewContent', viewProductInfo);
}

function getGASelectedProduct(selectedOption) {
   // ga() expects a string price, but let's give them one with minimal
   // formatting (e.g., no thousands separator) by converting our numeric price
   // to a string with exactly 2 decimal places.
   return {
      id: App.itemcode,
      name: App.productName, // The generic product name
      variant: selectedOption.name, // The specific product option selected
      category: Utils.parseItemcode(App.itemcode).category,
      price: selectedOption.purchasePrice.toFixed(2),
   };
}

function getFacebookSelectedProduct(selectedOption) {
   // fbq() expects `value` to be a float or int; the documentation isn't
   // explicit abtou item_price, but presumably it's the same because it also
   // represents a money value.
   return {
      value: selectedOption.purchasePrice,
      currency: 'USD',
      content_name: App.productName,
      content_type: 'product',
      contents: [
         {
            id: App.itemcode,
            item_price: selectedOption.purchasePrice,
         },
      ],
   };
}
